import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.SET_FORM_RESPONSES:
      return action.data;
    case Action.CLEAR_FORM_RESPONSES:
      return {};
    default: return state;
  }
};
